import React, { ReactNode } from 'react';
import Container from '@mui/material/Container';
import { makeStyles } from '@mui/styles';
import { Theme } from '@mui/material/styles';


const useStyles = makeStyles<Theme>((theme) => ({
  mainContainer: {
    display: 'flex',
    flexDirection: 'column',
    flexGrow: 1,
    paddingTop: '20px',
    marginTop: '20px',
    fontFamily: 'inherit',
    // Uncomment breakpoints as needed
    // [theme.breakpoints.up('xs')]: {
    //   margin: '20px 20px 0',
    // },
    // [theme.breakpoints.up('sm')]: {
    //   margin: '20px 0 0',
    // },
  },
}));

const Body: React.FC<React.PropsWithChildren<any>> = ({ children }) => {
  const styles = useStyles();

  return (
    <Container maxWidth="xl" className={styles.mainContainer}>
      {children}
    </Container>
  );
};

export default Body;
